import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-credit-line-lead-info',
  templateUrl: './credit-line-lead-info.component.html',
  styleUrls: ['./credit-line-lead-info.component.scss']
})
export class CreditLineLeadInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
